export const normalizeString = (str: string) =>
  str
    .toLowerCase()
    .trim()
    .replace(",", ".")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
